<template lang="pug">
  .wrap-profile-details
    h1 {{ fullName }}
    table.profile-details
    tr
      td {{ $t('user.id') }}
      td {{ profile.id }}
    tr
      td {{ $t('user.email') }}
      td {{ profile.email }}
    tr
      td {{ $t('user.organization') }}
      td {{ profile.organization_name }}
    tr
      td {{ $t('user.department') }}
      td {{ profile.department }}
    tr
      td {{ $t('user.phones') }}
      td
        ul.phones-list
          li(
            v-for="(phone, index) in phones"
            :key="index"
          )
            span {{ phone }}

</template>

<script>
  import { isEmpty } from 'lodash'

  export default {
    props: {
      profile: {
        type: Object,
        default() {
          return {}
        }
      }
    },

    computed: {
      phones() {
        return this.profile.phones.map(({ number, extension }) => {
          return isEmpty(extension) ? number : `${number} (${extension})`
        })
      },

      fullName() {
        return `${this.profile.first_name} ${this.profile.last_name}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrap-profile-details {
    padding-top: 2%;

    h1 {
      color: #3d4a57;
      font-size: 22px;
      font-weight: 700;
      letter-spacing: 0;
      margin: 2% 0;
    }
  }

  .profile-details {
    tr {
      background: #fcfdfe;
      box-shadow: 0 1px 0 0 #edf2f6, 0 -1px 0 0 #edf2f6;
      height: 40px;

      td {
        padding-top: 10px;
        width: 270px;

        &:first-child {
          color: #7c91a7;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0;
        }

        &:last-child {
          color: #313541;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0;
        }

        ul {
          padding-left: 22px;
        }
      }
    }
  }
</style>
